// @ts-nocheck

import type { FunctionalComponent } from 'vue'
import PageContainer from '~/components/page/container.vue'
import XCardTab from '~/components/xCardTab/index.vue'
import UpgradeRights from '~/features/upgradeRights/index.vue'
import EmptyViewLogin from '~/components/emptyView/login.vue'
import { USER_LEVEL_KEY } from '~/api/interface'
import { PageKey } from '~/constants/page'

type FComponentProps = {
  title?: string
  tabKey: string | number
  tabName: string
  loading?: boolean
  destroyInactiveTabPane?: boolean
}

type Events = {
  tabChange(key: string): void
  tabScrollBottom(key: string): void
}

const FComponent: FunctionalComponent<FComponentProps, Events> = (
  props,
  { emit, slots }
) => {
  const currentAccount = useUserInfo()
  const route = useRoute()
  const upRouteName = [PageKey.TEAM_SPACE, PageKey.BRAND_MANAGE] // 共享空间、品牌规范
  const upLevel = [
    USER_LEVEL_KEY.TASTE,
    USER_LEVEL_KEY.PERSONAL,
    USER_LEVEL_KEY.PERSONAL_LITE,
  ] // 个人版、体验版

  const isSuggestOrder = computed(
    () =>
      upRouteName.includes(route.name) &&
      upLevel.includes(Number(currentAccount?.value?.rights_type))
  )

  const isSuggest = computed(() => upRouteName.includes(route.name))

  const handleTabChange = (key: string) => {
    emit('update:tabKey', key)
    emit('tabChange', key)
  }
  const tabSlots = Object.entries(slots).reduce((acc, [key, value]) => {
    if (!['title', 'pageExtra', 'default', 'rightExtra'].includes(key)) {
      acc[key] = value
    }
    return acc
  }, {})

  const getTemplate = () => {
    if (isSuggestOrder.value || (isSuggest && !currentAccount.value?.user_id)) {
      return <UpgradeRights />
    }

    if (!currentAccount.value?.user_id) {
      return <EmptyViewLogin />
    }

    return slots.default?.()
  }

  return (
    <PageContainer title={props.title}>
      {{
        title: slots.title,
        pageExtra: slots.pageExtra,
        pageTop: slots.pageTop,
        default: () => [
          !isSuggestOrder.value && currentAccount.value?.user_id ? (
            <XCardTab
              name={props.tabName}
              modelValue={props.tabKey}
              onUpdate:modelValue={handleTabChange}
              destroyInactiveTabPane={props.destroyInactiveTabPane}
            >
              {{
                rightExtra: slots.rightExtra,
                ...(isSuggestOrder.value ? {} : tabSlots),
              }}
            </XCardTab>
          ) : undefined,
          getTemplate(),
        ],
      }}
    </PageContainer>
  )
}

export default FComponent
